declare var angular: any;

import { enableProdMode, StaticProvider } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { downgradeComponent, downgradeInjectable, downgradeModule } from '@angular/upgrade/static';
import { TranslateService } from '@ngx-translate/core';
import { AppModule } from './app/app.module';
import { EmbeddedViewComponent } from './app/embedded-view/embedded-view.component';
import { MenuComponent } from './app/rl-common/menu/menu.component';
import { BootstrapServicesComponent } from './app/bootstrap-services/bootstrap-services.component';
import { FeaturesRecommendationComponent } from './app/features-management/features-recommendation/features-recommendation.component';
import { DialogService } from './app/rl-common/dialogs/core/dialog.service';
import { FeatureService } from './app/features-management/core/feature.service';
import { BoxTabsComponent } from './app/rl-common/tabs/box-tabs/box-tabs.component';
import { SelectionToolbarComponent } from './app/item-selection/selection-toolbar/selection-toolbar.component';
import { SectionsListComponent } from './app/section/sections-list/sections-list.component';
import { SidePanelComponent } from './app/side-panel/side-panel/side-panel.component';
import { AppComponent } from './app/app.component';
import { NgService } from './app/core/ng.service';
import { ToggleButtonComponent } from './app/rl-common/buttons/toggle-button/toggle-button.component';
import { TagsContainerComponent } from './app/tags/tags-container/tags-container.component';
import { RequestComponent } from './app/requests/request/request.component';
import { ContentAccessComponent } from './app/rl-common/link-access/content-access/content-access.component';
import { environment } from './environments/environment';
import { ParentReadingListComponent } from './app/parent-reading-list/parent-reading-list.component';
import { MoreInfoComponent } from './app/rl-common/more-info/more-info.component';

var ngJS = angular.module('readingListApp');

if (environment.production) {
  enableProdMode();
}

if (!environment.isNewUI) {
  const bootstrapFn = (extraProviders: StaticProvider[]) => {
    const platformRef = platformBrowserDynamic(extraProviders);
    return platformRef.bootstrapModule(AppModule);
  };
  //downgraded components
  ngJS.directive('bootstrapServices', downgradeComponent({ component: BootstrapServicesComponent }) as any);
  ngJS.directive('rlEmbeddedView', downgradeComponent({ component: EmbeddedViewComponent }));
  ngJS.directive('rlMenu', downgradeComponent({ component: MenuComponent, propagateDigest: false }) as any);
  ngJS.directive('rlFeaturesRecommendation', downgradeComponent({ component: FeaturesRecommendationComponent }) as any);
  ngJS.directive('rlBoxTabs', downgradeComponent({ component: BoxTabsComponent }) as any);
  ngJS.directive('rlSectionsList', downgradeComponent({ component: SectionsListComponent }) as any);
  ngJS.directive('rlSelectionToolbar', downgradeComponent({ component: SelectionToolbarComponent }) as any);
  ngJS.directive('rlSidePanel', downgradeComponent({ component: SidePanelComponent }) as any);
  ngJS.directive('rlNgApp', downgradeComponent({ component: AppComponent }) as any);
  ngJS.directive('rlToggleButton', downgradeComponent({ component: ToggleButtonComponent }) as any);
  ngJS.directive('rlTagsContainer', downgradeComponent({ component: TagsContainerComponent, propagateDigest: false }) as any);
  ngJS.directive('rlContentAccess', downgradeComponent({ component: ContentAccessComponent, propagateDigest: false }) as any);
  ngJS.directive('rlRequest', downgradeComponent({ component: RequestComponent }) as any);
  ngJS.directive('rlParentReadingList', downgradeComponent({ component: ParentReadingListComponent }) as any);
  ngJS.directive('rlMoreInfo', downgradeComponent({ component: MoreInfoComponent }) as any);

  //downgraded services
  ngJS.factory('NgTranslateService', downgradeInjectable(TranslateService) as any);
  ngJS.factory('DialogService', downgradeInjectable(DialogService) as any);
  ngJS.factory('FeatureService', downgradeInjectable(FeatureService) as any);
  ngJS.factory('NgService', downgradeInjectable(NgService) as any);

  const downgradedModule = downgradeModule(bootstrapFn);
  ngJS.requires.push(downgradedModule);

  angular.bootstrap(document.getElementById('rlApp'), ['readingListApp']);
} else {
  platformBrowserDynamic().bootstrapModule(AppModule);
}
